/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Short_Code_Not_FoundInputs */



/**
* | output |
* | --- |
* | "No event answers to {code}." |
*
* @param {Short_Code_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const short_code_not_found = /** @type {((inputs: Short_Code_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Short_Code_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucun tournoi ne répond à ${i?.code}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ningún torneo responde a ${i?.code}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Nenhum torneio responde a ${i?.code}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Nessun torneo risponde a ${i?.code}.`)
	return /** @type {LocalizedString} */ (`No event answers to ${i?.code}.`)
});